import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { Injectable } from '@angular/core';
import { ConstantsService } from './constants.service';

@Injectable()
export class ReporteResumenObraService {
  public api_url: string;
  public modulo_url: string;
  public service_url: string;
  constructor(private http: Http, private authService: AutenticacionService, private constantService: ConstantsService) {
    this.api_url = this.constantService.apiURL;
    this.modulo_url = '/reportes/reporte-resumen-obra';
    this.service_url = this.api_url + this.modulo_url;
  }

  getObras(){
    return this.http.get(this.service_url + '/obras?select=true', this.authService.getAuthHeaders());
  }

  getReporteResumenDeObra(idObras, fecha) {
    return this.http.get(this.service_url + '/generar?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }
  
  getReporteResumenDeDiferencias(idObras, fechaInicial, fechaFinal) {
    return this.http.get(this.service_url + '/generarDiferencias?fechaInicial=' + fechaInicial + '&fechaFinal='+ fechaFinal +'&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraFecha(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/fecha?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraCuentas(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/cuentas?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraTraspasos(idObras, fecha,isResumenDeDiferencias) {
    return this.http.get(this.service_url + '/generar/traspasos?fecha=' + fecha + '&obra=' + idObras + '&isResumenDeDiferencias='+ isResumenDeDiferencias, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraRetornos(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/retornos?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }
  
  getReporteResumenDeObraHonorarios(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/honorarios?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraTotales(idObras, fecha, isResumenDeDiferencias) {
    return this.http.get(this.service_url + '/generar/totales?fecha=' + fecha + '&obra=' + idObras + '&isResumenDeDiferencias='+ isResumenDeDiferencias, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraTiposMovimiento(idObras, fecha, isResumenDeDiferencias) {
    return this.http.get(this.service_url + '/generar/movimientos?fecha=' + fecha + '&obra=' + idObras + '&isResumenDeDiferencias='+ isResumenDeDiferencias, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraPorProveedores(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/por-proveedores?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraProveedores(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/proveedores?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

  getReporteResumenDeObraGruposProveedores(idObras, fecha) {
    return this.http.get(this.service_url + '/generar/grupos-proveedores?fecha=' + fecha + '&obra=' + idObras, this.authService.getAuthHeaders());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/reporte-resumen-obra.service.ts